import 'core/utils/publicPath';
import React from 'react';
import Loadable from 'react-loadable';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import RoutesWrap from 'core/routes';
import { Provider } from 'react-redux';
import { MediaQueries } from 'core/modules/MediaQueries/MediaQueries';
import ModalRoot from 'core/modules/Modal/_can/ModalRoot';
import PopupRoot from 'core/modules/Popup/_can/PopupRoot';
import ModalProvider from 'core/modules/Modal/ModalProvider';
import PopupProvider from 'core/modules/Popup/PopupProvider';

import './styles/_can/style.scss';

import getStore from './store';

const LoadableWrapper = PageComponent => Loadable({
  loader: () => import(`./pages/_can${PageComponent}`),
  loading: () => (null),
});

const routesConfig = [
  { route: '/button', PageComponent: LoadableWrapper('/ButtonLanding') },
  { route: '/ai____.htm', PageComponent: LoadableWrapper('/Profile') },
  { route: '/p/:dynamicPage', PageComponent: LoadableWrapper('/DynamicRewards') },
  { route: '/me____.htm', PageComponent: LoadableWrapper('/MerchantExperience') },
];

const store = getStore(true);

const render = () => {
  const container = document.createElement('div');
  container.id = 'app';
  document.body.appendChild(container);

  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <MediaQueries>
          <ModalProvider>
            <PopupProvider>
              <RoutesWrap orgRoutesConfig={routesConfig} isCan />
              <ModalRoot />
              <PopupRoot />
            </PopupProvider>
          </ModalProvider>
        </MediaQueries>
      </BrowserRouter>
    </Provider>,
  );
};

render();
